// Module
var code = "<p class=\"note mt-3rem\"><strong>NOTE:</strong> If you don&#39;t have your account number, <a href=\"/login\" target=\"_blank\">sign in to Account Access</a> to obtain it.</p> ";
// Exports
export default code;